import Vue from 'vue';

export const automationsMixin = {
    mixins: [],
    computed: {
    },
    methods: {
        setAppliedToAllBookingsOnAllAutomations: function(list) {
            for (let automation of list) {
                if (automation.conditions && automation.conditions.length > 0) {
                    Vue.set(automation, 'appliesToAllBookings', false);
                } else {
                    Vue.set(automation, 'appliesToAllBookings', true);
                }
            }
        },
        sortAllAutomations: function(list) {
            list.sort((first, second) => {
                switch (first.when.strategy) {
                    case 'immediate':
                    case 'after-booking':
                        if (second.when.strategy === 'immediate' || second.when.strategy === 'after-booking') {
                            return this.compareByNumberOfDaysFrom(first, second);
                        }
                        return -1;
                    case 'before-or-after-arrival':
                        switch (second.when.strategy) {
                            case 'immediate':
                            case 'after-booking':
                                return 1;
                            case 'before-or-after-arrival':
                                return this.compareByNumberOfDaysFrom(first, second);
                        }
                        return -1;
                    case 'before-or-after-departure':
                        if (second.when.strategy === 'before-or-after-departure') {
                            return this.compareByNumberOfDaysFrom(first, second);
                        }
                        return 1;
                }
            });
        },
        sortAutomationFlowByNumberOfDaysFrom: function(list) {
            list.sort(this.compareByNumberOfDaysFrom);
        },
        compareByNumberOfDaysFrom: function (first, second) {
            if (first.when.numberOfDaysFrom > second.when.numberOfDaysFrom) {
                return 1;
            } else if (first.when.numberOfDaysFrom < second.when.numberOfDaysFrom) {
                return -1;
            } else {
                if (first.name < second.name) {
                    return -1;
                } else if (first.name > second.name) {
                    return 1;
                }
                return 0;
            }
        },
        isAutomationTimeOfDayLessThanHour: function(automation, hour) {
            let hours = automation.when.timeOfDay.split(":")[0];
            let hoursNum = parseInt(hours);
            if (hoursNum < hour) {
                return true;
            } else {
                return false;
            }
        },
        isAnAutomationWithAForm: function(automation) {
            switch (automation.type) {
                case 'send-omni-channel-guest-form':
                case 'guest-form':
                    return true;
            }
            return false;
        },
        isAnAutomationWithAnEmail: function(automation) {
            switch (automation.type) {
                case 'send-omni-channel-guest-form':
                case 'send-email':
                case 'upsell':
                    return true;
            }
            return false;
        },
        isAnAutomationWithAnSMS: function(automation) {
            switch (automation.type) {
                case 'send-omni-channel-guest-form':
                case 'send-sms':
                case 'upsell':
                    if (automation.sendSMS) {
                        return true;
                    }
            }
            return false;
        },
        isAnAutomationWhatsApp: function(automation) {
            switch (automation.type) {
                case 'send-whatsapp':
                    return true;
            }
            return false;
        },
        isAnAutomationUpsell: function(automation) {
            switch (automation.type) {
                case 'upsell':
                    return true;
            }
            return false;
        },
        isAnAutomationToDo: function(automation) {
            switch (automation.type) {
                case 'to-do':
                    return true;
            }
            return false;
        },
        isAnAutomationWebhook: function(automation) {
            switch (automation.type) {
                case 'webhook':
                    return true;
            }
            return false;
        },
    }
}